import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import NumberFormat from 'react-number-format';
import { numberFormat } from 'constants/formats';

import { useDividendsDistributionModal } from '../context/DividendsDistributionModalContext';
import DividendsTable from './DividendsTable';

const DividendsDistributionModalDataView: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useDividendsDistributionModal();

  return (
    <>
      <div className="form-group">
        <label className="form-label" htmlFor="pay-amount">
          {t('DividendsAmount')}
        </label>
        <div className="form-control-wrap">
          <div className="form-text-hint">
            <span className="overline-title">EUR</span>
          </div>
          <NumberFormat
            id="outlined-normal"
            className="form-control form-control-outlined"
            placeholder={t('Amount')}
            value={data.totalAmount}
            onChange={actions.handleChangeTotalAmount}
            thousandSeparator={numberFormat.thousandSeparator}
            decimalSeparator={numberFormat.decimalSeparator}
            allowNegative={false}
            required
          />
        </div>
      </div>

      <div className="form-group">
        <div className="custom-control custom-control-xs custom-checkbox">
          <input
            type="checkbox"
            id="checkbox-notifications"
            className="custom-control-input"
            checked={data.hasRetention}
            onChange={actions.handleChangeHasRetention}
          />
          <label
            className="custom-control-label"
            htmlFor="checkbox-notifications"
          >
            {t('DoYouWantToApplyRetention')}
          </label>
        </div>
      </div>

      {data.hasRetention && (
        <div className="form-group">
          <label className="form-label" htmlFor="pay-amount">
            {t('RetentionPercent')}
          </label>
          <span className="sub-text mb-3">{t('SetPercentAndUpdateLater')}</span>
          <div className="form-control-wrap">
            <div className="form-text-hint">
              <span className="overline-title">%</span>
            </div>
            <NumberFormat
              id="outlined-normal"
              className="form-control form-control-outlined"
              placeholder={t('Percent')}
              value={data.retentionPercentage}
              onChange={actions.handleChangeRetentionPercentage}
              thousandSeparator={numberFormat.thousandSeparator}
              decimalSeparator={numberFormat.decimalSeparator}
              allowNegative={false}
            />
          </div>
        </div>
      )}

      <DividendsTable />
    </>
  );
};

export default DividendsDistributionModalDataView;
